<div class="tab-pane" role="tabpanel" id="empresa">
    <fieldset id="agregar_empresa" class="">
        <div class="step_section">
            <h3 class="form-signin-heading"><strong>Informaci&oacute;n de la empresa</strong></h3>
            <hr/>
            <div class="row" id="row">
                <div class="col-md-12" id="content">
                    <p>Ingrese el RUT para agregar Empresa</p>
                    <div class="form-horizontal">
                        <div class="form-group"> 

                            <div  class="col-sm-12 col-md-4 col-lg-4">
                                <form [formGroup]="rut_emp">
                                    <mat-form-field class="example-full-width" style="width: 100%">
                                        <input matInput placeholder="Rut" id="rut_emp" name="rut_emp" formControlName="rut" formatRut [errorStateMatcher]="matcher">
                                        <mat-error *ngIf="rut_emp && rut_emp.controls?.rut.hasError('invalidRut')">
                                            Este rut es <strong>invalido</strong>
                                        </mat-error>
                                    </mat-form-field>
                                </form>
                            </div>                                                   
                            <div class="col-sm-12 col-md-4 col-lg-4 text-left">
                                <button mat-raised-button color="primary" style="padding-top: 5px" id="b_rut_emp" [disabled]="!rut_emp.valid" (click)="get_empresa(rut_emp.controls.rut.value)">
                                            Agregar Empresa
                                        <mat-icon aria-label="icon">add_circle_outline</mat-icon>
                                </button>
                            </div>
                            <div class="col-sm-12 col-md-4 col-lg-4"></div>
                            

                        </div>
                    </div>

                    <!--Detalle de los empresas-->
                    <div class="datatable_antecedentes">
                        <ngx-datatable class="material expandable" [messages]="''" [rows]="rows" [columnMode]="'force'" [headerHeight]="'auto'" [footerHeight]="'auto'" [rowHeight]="'auto'">
                            <ngx-datatable-column>
                                <ng-template ngx-datatable-header-template>
                                    <span>RUT</span>
                                </ng-template>
                                <ng-template let-row="row" ngx-datatable-cell-template>
                                    {{row.rut}}
                                </ng-template>
                            </ngx-datatable-column>
                            <ngx-datatable-column>
                                <ng-template ngx-datatable-header-template>
                                    <span>NOMBRE EMPRESA</span>
                                </ng-template>
                                <ng-template let-row="row" ngx-datatable-cell-template>
                                    <span>{{row.nombre}}</span>
                                </ng-template>
                            </ngx-datatable-column>
                            <ngx-datatable-column>
                                <ng-template ngx-datatable-header-template>
                                    <span>OPCIONES</span>
                                </ng-template>
                                <ng-template let-row="row" let-rowIndex="rowIndex" ngx-datatable-cell-template>
                                    <span (click)="update_empresa(row.rut,rowIndex)" style="padding-right: 5px;"><i class="glyphicon glyphicon-eye-open"></i></span>
                                    <span (click)="delete_empresa(rowIndex)"><i class="glyphicon glyphicon-trash"></i></span>
                                </ng-template>
                            </ngx-datatable-column>

                        </ngx-datatable>
                    </div>
                </div>

            </div>
        </div>
    </fieldset>
    <!--Material dialog modal-->
    <ng-template #openModal>
        
        <mat-dialog-content class="text-center">

            <h2 mat-dialog-title>Ingresar informaci&oacute;n de la empresa</h2>
            <div class="form-horizontal">
                <div class="alert alert-info" role="alert">
                    <i class="fa fa-info-circle" aria-hidden="true"></i>
                    <strong> Debe ingresar la informacion de la empresa</strong>, su solicitud pasar&aacute;<br> por un proceso de verificaci&oacute;n de la empresa ingresada. <br>
                    <i class="fa fa-exclamation-circle" aria-hidden="true"></i>
                    <strong> Campos obligatorios marcados con un (<span style="color: red">*</span>)</strong>
                </div>

                <div class="form-group">
                    <div class="col-md-2"></div>
                    <div class="col-md-8">
                        <mat-form-field class="example-full-width" style="width: 100%">
                        <input matInput id="rut" name="rut" type="text" placeholder="RUT" class="" [(ngModel)]="empresa.rut" readonly>
                        </mat-form-field>
                    </div>
                    <div class="col-md-2"></div>
                </div>

                <div class="form-group">
                    <div class="col-md-2"></div>
                    <div class="col-md-8">
                        <mat-form-field class="example-full-width" style="width: 100%">
                        <input matInput id="nombre_empresa" name="nombre_empresa" type="text" placeholder="Raz&oacute;n Social" [(ngModel)]="empresa.nombre" class="">
                        </mat-form-field>
                    </div>
                    <div class="col-md-2"></div>
                </div>

                <div hidden="hidden">
                    <div class="form-group">
                        <div class="col-md-1"></div>
                        <label class="col-md-2 control-label" for="dir_calle_empresa">Calle (<span style="color: red">*</span>)</label>
                        <div class="col-md-3">
                            <input id="dir_calle_empresa" name="dir_calle_empresa" type="text" placeholder="Calle" [(ngModel)]="empresa.direccion" class="form-control input-md">
                        </div>
                        <label class="col-md-2 control-label" for="dir_num_empresa">Numero (<span style="color: red">*</span>)</label>
                        <div class="col-md-3">
                            <input id="dir_num_empresa" name="dir_num_empresa" type="text" placeholder="Numero" [(ngModel)]="empresa.direccion_num" class="form-control input-md">
                        </div>
                    </div>
                    <div class="form-group">
                        <label class="col-md-4 control-label" for="comuna">Comuna(<span style="color: red">*</span>) </label>
                        <div class="col-md-6">
                            <mat-form-field class="example-full-width">
                                <input type="text" id="Com_nombre" name="Com_nombre" aria-label="Nombre" matInput [formControl]="nombreComuna" [matAutocomplete]="auto" [(ngModel)]="empresa.comuna">
                                <mat-autocomplete #auto="matAutocomplete">
                                <mat-option *ngFor="let option of filteredOptions | async" [value]="option">
                                    {{option}}
                                </mat-option>
                                </mat-autocomplete>
                            </mat-form-field>
                            <!-- <input id="comuna" name="comuna" type="text" placeholder="Comuna" [(ngModel)]="propietario.comuna" class="form-control input-md"> -->
                        </div>
                        <div class="col-md-2"></div>
                    </div>
                    <div class="form-group">
                        <div class="col-md-1"></div>
                        <label class="col-md-2 control-label" for="dir_completa_empresa">Direccion Completa</label>
                        <div class="col-md-3">
                            <input id="dir_completa_empresa" name="dir_completa_empresa" type="text" placeholder="Completa" [(ngModel)]="empresa.direccion_completa" class="form-control input-md">
                        </div>
                        <label class="col-md-2 control-label" for="fax_empresa">Fax</label>
                        <div class="col-md-3"><input id="fax_empresa" name="fax_empresa" type="text" placeholder="fax" [(ngModel)]="empresa.fax_empresa" class="form-control input-md">
                        </div>
                    </div>
                </div>

                <div class="form-group">
                    <div class="col-md-2"></div>
                    <div class="col-md-8">
                        <mat-form-field class="example-full-width" style="width: 100%">
                        <input matInput id="fono_empresa" name="fono_empresa" type="text" placeholder="Tel&eacute;fono" [(ngModel)]="empresa.fono" class="">
                        </mat-form-field>
                    </div>
                    <div class="col-md-2"></div>
                </div>

                <form [formGroup]="mail_emp">
                    <div class="form-group">
                        <div class="col-md-2"></div>
                        <div class="col-md-8">
                            <mat-form-field style="width: 100%;" floatLabel="never">
                                <input matInput type="email" placeholder="Email(*)" id="email_propiet" name="email_propiet"
                                    formControlName="mail"[(ngModel)]="empresa.mail" class="">
                                <mat-error *ngIf="mail_emp.controls.mail.errors?.required">Email requerido
                                </mat-error>
                                <mat-error *ngIf="mail_emp.controls.mail.errors?.pattern">Formato incorrecto.
                                    Ej:
                                    correo@servidor.dominio. </mat-error>
                                <mat-error *ngIf="mail_emp.controls.mail.errors?.maxlength">Excede el máximo de
                                    caracteres
                                    (50). </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-md-2"></div>
                    </div>
                </form>
               <!--  <div class="form-group">
                    <label class="col-md-4 control-label" for="email_empresa">Email(<span style="color: red">*</span>)</label>
                    <div class="col-md-6">
                        <input id="email_empresa" name="email_empresa" type="email" placeholder="mail@ejemplo.com" [(ngModel)]="empresa.mail" class="form-control input-md">
                    </div>
                    <div class="col-md-2"></div>
                </div> -->
            </div>
        </mat-dialog-content>
        <mat-dialog-actions align="center">
            <button matDialogClose mat-raised-button color="warn" id="clean_ingreso_empresa" data-dismiss="modal" (click)="cleanData()">Cancelar</button>
            <button mat-raised-button color="primary" id="ingreso_empresa" (click)="saveEmpresa()" [disabled]="!empresa.rut || !empresa.nombre || !empresa.mail || mail_emp.status == 'INVALID'">Ingresar Empresa <i class="fa fa-user-o" aria-hidden="true"></i></button>

        </mat-dialog-actions>
    </ng-template>
    <!--End Material dialog modal-->

    
</div>
<div class="separator"></div>